import { FC, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'react-bootstrap'

// hooks
import { useApi } from 'landing-page/hooks/useApi'
import { api, AlumniProfileType, AlumniSubmissionType } from 'landing-page/types/api'

// layout
import MainLayout from 'landing-page/components/layouts/MainLayout'

// components
import Section from 'landing-page/components/common/Section'
import Container from 'landing-page/components/common/Container'

const History: FC = () => {

    const [user, setUser] = useState<AlumniProfileType | null>(null)

    const [submissionsData, setSubmissionsData] = useState<AlumniSubmissionType[] | null>([])

    const navigate = useNavigate()

    // Get profile alumni
    const { data, execute: executeGetProfileAlumni, loading, error, reset: resetGetProfileAlumni } = useApi(api.getProfileAlumni.bind(api));

    const { data: submissionsDataApi, execute: executeGetSubmissionsAlumni, loading: submissionsLoading, error: submissionsError, reset: resetGetSubmissionsAlumni } = useApi(api.getSubmissionsAlumni.bind(api));

    // Get profile alumni on mount
    useEffect(() => {
        executeGetProfileAlumni()
    }, [])

    useEffect(() => {
        if (data?.data) {
            setUser(data?.data as AlumniProfileType)
            executeGetSubmissionsAlumni()
        }
    }, [data])

    useEffect(() => {
        if (submissionsDataApi?.data?.submissions) {
            setSubmissionsData(submissionsDataApi?.data?.submissions as AlumniSubmissionType[])
        }
    }, [submissionsDataApi])

    // Handle expired token
    useEffect(() => {
        if (error) {
            console.error('Error details:', {
                status: error.status,
                message: error.message,
                fullError: error
            })
            
            // Check if it's a 401 error with "Token kadaluarsa" message
            if (error.status === 401 && error.message === 'Token kadaluarsa.') {
                // Clear the expired token
                api.clearToken()
                // save the current path
                localStorage.setItem('currentPath', window.location.pathname)
                // redirect to ajukan-profil
                navigate('/ajukan-profil')
            }

            if (error.status === 401 && error.message === 'Token wajib diisi.') {
                // Clear the expired token
                api.clearToken()
                // save the current path
                localStorage.setItem('currentPath', window.location.pathname)
                // redirect to ajukan-profil
                navigate('/ajukan-profil')
            }
        }
    }, [error])

    const headerProps = {
        user: user // user from API
    }

    return (
        <MainLayout headerProps={headerProps}>
            <Section className='py-15 mt-15' variant='white'>
                <Container>
                    <div>
                        <h1 className='fs-1' style={{textTransform: 'unset', lineHeight: '2'}}>Riwayat Pengajuan</h1>
                        <Breadcrumb>
                            <Breadcrumb.Item className=''>
                                <Link to="/" className='text-muted text-hover-primary'>Beranda</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className=''><i className='bi bi-chevron-right text-dark'></i></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link className='text-muted text-hover-primary' to="/ajukan-profil">Pengajuan Alumni</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className=''><i className='bi bi-chevron-right text-dark'></i></Breadcrumb.Item>
                            <Breadcrumb.Item active>Riwayat Pengajuan</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className='mt-10 table-responsive'>
                        <table className='table table-striped align-middle'>
                            <thead>
                                <tr>
                                    <th>Nama</th>
                                    <th>Program</th>
                                    <th>Universitas</th>
                                    <th>Tanggal Pengajuan</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {submissionsData?.map((item: AlumniSubmissionType) => (
                                    <tr key={item.alumni_profile_id}>
                                        <td>{item.nama_alumni}</td>
                                        <td>{item.program}</td>
                                        <td>{item.universitas}</td>
                                        <td>{item.tanggal_pengajuan}</td>
                                        <td>{item.status}</td>
                                    </tr>
                                ))}
                                {submissionsData?.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className='text-center'>Tidak ada data</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Container>
            </Section>
        </MainLayout>
    )
}

export default History